import {
  OPT_WORKFLOWS_LIST_STATUS_ALL_VALUE,
  OPT_WORKFLOWS_LIST_TYPE_ALL__VALUE
} from 'Constants/'
import { atom, atomFamily } from 'recoil'

export const searchState = atom({
  key: 'WorkflowsListSearchState',
  default: {
    searchText: '',
    status: OPT_WORKFLOWS_LIST_STATUS_ALL_VALUE,
    type: OPT_WORKFLOWS_LIST_TYPE_ALL__VALUE,
    tagIds: [],
    filterMessages: [],
    filterMessagesSelected: new Map(),
    idMessages: undefined
  }
})

export const searchResult = atom({
  key: 'WorkflowsListSearchResult',
  default: {
    items: undefined
  }
})

export const paginationState = atom({
  key: 'WorkflowsListPaginationState',
  default: {
    pageNumber: 1,
    pageSize: 10,
    totalItems: 0
  }
})

export const orderingState = atom({
  key: 'WorkflowsListOrderingState',
  default: {
    orderBy: 'LastModifiedDate',
    orderDescending: true
  }
})

export const tagsState = atom({
  key: 'WorkflowsListTagsState',
  default: []
})

export const messagesState = atom({
  key: 'WorkflowsListMessagesState',
  default: {
    items: [],
    count: 0,
    loading: false
  }
})

export const toggleStatusState = atomFamily({
  key: 'WorkflowsListToggleStatusState',
  default: {
    statusToggle: false,
    error: undefined
  }
})
